export const recordingTime={
     seconds3:'实时情绪识别',
     seconds30:'AI情绪检测',
}